/**
 * @class AppointmentBackendProvider
 */
function AppointmentBackendProvider() {
    let appointmentUrl, BdcUrl;

    this.setAppointmentURL = function setAppointmentURL(url) {
        appointmentUrl = url;
    };
    this.setBDCUrl = function setBdcURL(url) {
        BdcUrl = url;
    };

    this.$get = [
        '$q',
        '$http',
        '$log',
        function($q, $http, $log) {
            var self = {};

            /**
             * Get the store's appointments
             * @param  {String} storeId
             * @return {Promise}
             */
            self.getAppointments = function getAppointments(storeId) {
                // return $http.get(appointmentUrl + 'store/' + storeId + '/appointments').then(function(res) {
                //     return res.data;
                // });
                return $http.get(BdcUrl + 'appointments/' + storeId).then(function(res) {
                    return res.data;
                });
            };

            /**
             * Get the appointment purposes
             * @return {Promise}
             */
            self.getAppointmentPurposes = function getAppointmentPurposes(source) {
                return $http.get(BdcUrl + 'appointment/purposes/' + source).then(function(res) {
                    return res.data;
                });
            };

            /**
             * Get the appointment sources
             * @return {Promise}
             */
            self.getAppointmentSources = function getAppointmentSources() {
                return $http.get(BdcUrl + 'appointment/sources').then(function(res) {
                    return res.data;
                });
            };

            /**
             * Get the appointment provenances
             * @return {Promise}
             */
            self.getAppointmentProvenances = function () {
                return $http.get(BdcUrl + 'appointment/provenances').then(function(res) {
                    return res.data;
                });
            };

            /**
             * Get the appointment durations
             * @return {Promise}
             */
            self.getAppointmentDurations = function getAppointmentDurations() {
                return $http.get(BdcUrl + 'appointment/durations').then(function(res) {
                    return res.data;
                });
            };

            /**
             * Add a new appointment
             * @param {String} storeId
             * @param {Object} data
             * @return {Promise}
             */
            self.addNewAppointment = function addNewAppointment(storeId, data) {
                return $http.post(BdcUrl + 'appointment/' + storeId, data).then(function(res) {
                    return res.data;
                });
            };

            self.updateAppointmentStatus = (appointment) => {
                return $http.post(BdcUrl + 'appointment/update', appointment).then(res => {
                    return res.data;
                });
            }

            self.getAllAppointments = (filters) => {
                let baseUrl = BdcUrl + 'appointments?limit='+ filters.limit + '&offset=' + filters.offset * filters.limit;
                baseUrl += '&rds=[' + filters.rds.concat(filters.formerRDS).join(',') + ']';
                baseUrl += '&users=[' + filters.telepro.concat(filters.cs, filters.csd).join(',') + ']';

                if (filters.market && filters.market.length !== 0) {
                    baseUrl += '&market=[' + filters.market.join(',') + ']';
                }
                if (filters.purpose && filters.purpose.length !== 0) {
                    baseUrl += '&purpose=[' + filters.purpose.join(',') + ']';
                }
                if (filters.network !== undefined && filters.network !== null) {
                    baseUrl += '&network=' + filters.network;
                }
                if (filters.treated !== undefined && filters.treated !== null) {
                    baseUrl += '&treated=' + filters.treated;
                }
                if(filters.state !== undefined && filters.state !== null && filters.state.length !== 0) {
                    baseUrl += '&state=[' + filters.state.join(',') + ']';
                }
                if(filters.supplier !== undefined && filters.supplier !== null && filters.supplier.length !== 0) {
                    baseUrl += '&supplier=[' + filters.supplier.join(',') + ']';
                }
                if (filters.department !== undefined && filters.department !== null) {
                    baseUrl += '&department=' + filters.department;
                }
                if (filters.client !== undefined && filters.client !== null) {
                    baseUrl += '&client=' + filters.client;
                }
                if (filters.dateStart !== undefined && filters.dateStart !== null) {
                    baseUrl += '&dateStart=' + filters.dateStart;
                }
                if (filters.dateEnd !== undefined && filters.dateEnd !== null) {
                    baseUrl += '&dateEnd=' + filters.dateEnd;
                }

                return $http.get(baseUrl).then(res => {
                    return res.data;
                });
            };

            return self;
        }
    ];
}

angular
    .module('app.prospection.store.appointmentBackend', [])
    .provider('appointmentBackend', AppointmentBackendProvider);
